import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useModalContext } from '../contexts/ModalContext';

const LocationModal = ({ isOpen, onClose, attraction, t }) => {
  const modalRef = useRef(null);
  const { clickPosition } = useModalContext();

  useEffect(() => {
    if (isOpen && modalRef.current) {
      // Laisser le scroll libre
      // Ne pas modifier document.body.style.overflow

      const isMobile = window.innerWidth <= 768;

      if (isMobile) {
        // Sur mobile, on centre toujours la modale avec un léger décalage vers le bas
        modalRef.current.style.position = '';
        modalRef.current.style.left = '';
        modalRef.current.style.top = '';
        modalRef.current.style.transform = '';
        modalRef.current.style.margin = '0 auto';
        modalRef.current.style.marginTop = '50px';
      } else {
        // Desktop: laisser le centrage par défaut défini dans modal.css (fixed + translate)
        modalRef.current.style.position = '';
        modalRef.current.style.left = '';
        modalRef.current.style.top = '';
        modalRef.current.style.transform = '';
        modalRef.current.style.margin = '';
        modalRef.current.style.marginTop = '';
      }
    }

    // Pas de nettoyage nécessaire car nous ne modifions pas le style de scroll
  }, [isOpen]);

  if (!isOpen) return null;

  const openInMaps = () => {
    const { latitude, longitude } = attraction.location;
    const label = encodeURIComponent(attraction.name);
    
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isAndroid = /android/.test(userAgent);
    
    let url;
    if (isIOS) {
      url = `http://maps.apple.com/?q=${label}&ll=${latitude},${longitude}`;
    } else if (isAndroid) {
      url = `geo:${latitude},${longitude}?q=${latitude},${longitude}(${label})`;
    } else {
      url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}&query_place_id=${label}`;
    }
    
    window.open(url, '_blank');
  };

  // Vérifier si les coordonnées sont valides
  const hasValidCoordinates = attraction?.location?.latitude && attraction?.location?.longitude;

  const closeLabel = t ? t('closeModal') : 'Fermer la fenêtre';

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const handleOverlayKeyDown = (event) => {
    if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClose();
    }
  };

  // Utilisation de ReactDOM.createPortal pour rendre la modale directement dans le body
  return ReactDOM.createPortal(
    <div
      className="modal-overlay"
      role="button"
      tabIndex={0}
      aria-label={closeLabel}
      onClick={handleOverlayClick}
      onKeyDown={handleOverlayKeyDown}
      style={{
        // Positionner l'overlay à l'endroit du clic
        transformOrigin: clickPosition.x && clickPosition.y ?
          `${clickPosition.x}px ${clickPosition.y}px` : 'center center'
      }}
    >
      <div
        ref={modalRef}
        className="modal-content location-modal"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-header">
          <h3>{attraction.name}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {hasValidCoordinates ? (
            <>
              <div className="map-container">
                <iframe
                  title="Location Map"
                  width="100%"
                  height="300"
                  frameBorder="0"
                  scrolling="no"
                  src={`https://www.openstreetmap.org/export/embed.html?bbox=${attraction.location.longitude-0.001},${attraction.location.latitude-0.001},${attraction.location.longitude+0.001},${attraction.location.latitude+0.001}&layer=mapnik&marker=${attraction.location.latitude},${attraction.location.longitude}`}
                />
              </div>
              <button className="directions-button" onClick={openInMaps}>
                {navigator.userAgent.toLowerCase().includes('iphone') ? t('openInPlan') : t('openInMaps')}
              </button>
            </>
          ) : (
            <div className="error-message">
              {t('locationNotAvailable')}
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LocationModal; 
